import { render } from "./DataEditor.vue?vue&type=template&id=7bc7e5a6&scoped=true"
import script from "./DataEditor.vue?vue&type=script&lang=js"
export * from "./DataEditor.vue?vue&type=script&lang=js"

import "./DataEditor.vue?vue&type=style&index=0&id=7bc7e5a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc7e5a6"]])

export default __exports__